import { escrowStore } from '@/services/Escrow/store'
import { parseDate } from '@/utilities/Date/parse'
import parseAddress from '@/utilities/address/parse'
import _get from 'lodash/get'
import { notifyWarning } from '@/services/notify'

var DEFAULT_FORM_VALUES = {
  buyerName: '',
  buyerPhone: '',
  address: '',
  buyerEmail1: '',
  buyerEmail2: '',
  buyerEmail3: '',
  escrowType: '',
  escrowNumber: '',
  salePrice: 0,
  closingDate: null,
  disclosureDueDate: null,
  disclosureSentDate: null,
  completedDate: null,
  escrowLetterDocument: '',
  buyerNotificationLetter: '',
  sellerNotificationLetter: '',
  disclosureLetterDocument: '',
  titleCompanyName: '',
  titleCompanyContactName: '',
  titleCompanyContactEmail: '',
  inspectionRequired: 'false',
  inspectionDate: null
}

export const methods = {
  toggleFilters: function() {
    this.filters.show = !this.filters.show
  },

  async reload() {
    this.loading = true

    const dateFormat = 'MM/DD/YYYY'

    console.debug('route values=' + JSON.stringify(this.$route.params))

    this.escrowID = this.$route.params.id
    this.escrowBuyerName = this.$route.params.name

    console.debug('viewOnly=' + this.viewOnly)

    this.formData = { ...DEFAULT_FORM_VALUES }

    await this.loadEscrowByID()

    if (this.escrowDetail) {
      try {
        this.formData.buyerName = _get(this.escrowDetail, 'buyerName', '')
        this.formData.buyerPhone = _get(this.escrowDetail, 'buyerPhone', '')
        this.formData.buyerEmail1 = _get(this.escrowDetail, 'buyerEmail1', '')
        this.formData.buyerEmail2 = _get(this.escrowDetail, 'buyerEmail2', '')
        this.formData.buyerEmail3 = _get(this.escrowDetail, 'buyerEmail3', '')
        this.formData.escrowType = _get(this.escrowDetail, 'escrowType', '')
        this.formData.escrowNumber = _get(this.escrowDetail, 'escrowNumber', '')
        this.formData.salePrice = _get(this.escrowDetail, 'salePrice', 0)

        let tempInspectionRequired = _get(this.escrowDetail, 'inspectionRequired', false)

        this.formData.inspectionRequired = tempInspectionRequired === true ? 'true' : 'false'

        this.formData.inspectionDate = parseDate(
          _get(this.escrowDetail, 'inspectionDate', null),
          dateFormat
        )

        this.formData.closingDate = parseDate(
          _get(this.escrowDetail, 'closingDate', null),
          dateFormat
        )
        this.formData.disclosureDueDate = parseDate(
          _get(this.escrowDetail, 'disclosureDueDate', null),
          dateFormat
        )
        this.formData.disclosureSentDate = parseDate(
          _get(this.escrowDetail, 'disclosureSentDate', null),
          dateFormat
        )
        this.formData.completedDate = parseDate(
          _get(this.escrowDetail, 'completedDate', null),
          dateFormat
        )
        this.formData.buyerNotificationLetter = _get(
          this.escrowDetail,
          'buyerNotificationLetterDocumentFile',
          ''
        )
        this.formData.sellerNotificationLetter = _get(
          this.escrowDetail,
          'sellerNotificationLetterDocumentFile',
          ''
        )
        this.formData.disclosureLetterDocument = _get(
          this.escrowDetail,
          'disclosureLetterDocumentFile',
          ''
        )
        this.formData.escrowLetterDocument = _get(this.escrowDetail, 'escrowLetterDocumentFile', '')
        this.formData.titleCompanyName = _get(this.escrowDetail, 'titleCompanyName', '')
        this.formData.titleCompanyContactName = _get(
          this.escrowDetail,
          'titleCompanyContactName',
          ''
        )
        this.formData.titleCompanyContactEmail = _get(
          this.escrowDetail,
          'titleCompanyContactEmail',
          ''
        )

        this.formData.address = parseAddress({
          address: _get(this.escrowDetail, 'unit.address', '')
        })
      } catch (e) {
        console.debug('error while loading the escrow detail data:' + e)
      }
    }

    this.loading = false
  },

  async loadEscrowByID() {
    await escrowStore
      .dispatch('getEscrowById', {
        escrowID: this.escrowID
      })
      .then(({ result }) => {
        if (result) {
          this.escrowDetail = result
        }
      })
  },

  async openEscrowLetterDocument() {
    await this.getDocumentFile('EscrowLetterDocument')
  },

  async openBuyerNotificationLetter() {
    await this.getDocumentFile('BuyerNotificationLetterDocument')
  },

  async openSellerNotificationLetter() {
    await this.getDocumentFile('SellerNotificationLetterDocument')
  },

  async openDisclosureLetterDocument() {
    await this.getDocumentFile('DisclosureLetterDocument')
  },

  async getDocumentFile(type) {
    if (type === 'EscrowLetterDocument') {
      try {
        var link1 = document.createElement('a')
        link1.download = 'download.pdf'
        link1.setAttribute('download', 'download.pdf')
        link1.href = this.escrowDetail.escrowLetterDocumentURL
        window.open(link1, '_blank')
      } catch (e) {
        console.debug(e)
        notifyWarning('There was a problem loading the escrow letter document.')
      }
    } else if (type === 'DisclosureLetterDocument') {
      try {
        var link2 = document.createElement('a')
        link2.download = 'download.pdf'
        link2.setAttribute('download', 'download.pdf')
        link2.href = this.escrowDetail.disclosureLetterDocumentURL
        window.open(link2, '_blank')
      } catch (e) {
        console.debug(e)
        notifyWarning('There was a problem loading the disclosure letter document.')
      }
    } else if (type === 'SellerNotificationLetterDocument') {
      try {
        var link3 = document.createElement('a')
        link3.download = 'download.pdf'
        link3.setAttribute('download', 'download.pdf')
        link3.href = this.escrowDetail.sellerNotificationLetterDocumentURL
        window.open(link3, '_blank')
      } catch (e) {
        console.debug(e)
        notifyWarning('There was a problem loading the seller notification letter document.')
      }
    } else if (type === 'BuyerNotificationLetterDocument') {
      try {
        var link4 = document.createElement('a')
        link4.download = 'download.pdf'
        link4.setAttribute('download', 'download.pdf')
        link4.href = this.escrowDetail.buyerNotificationLetterDocumentURL
        window.open(link4, '_blank')
      } catch (e) {
        console.debug(e)
        notifyWarning('There was a problem loading the buyer notification letter document.')
      }
    }
    //  try {
    //     const params = {
    //       escrowID: this.escrowID,
    //       documentType: type,
    //       asBase64: true,
    //       asRawBase64: true
    //     }

    //     await escrowStore.dispatch('getFileByType', {
    //       params,
    //       done: ({ details }) => {
    //         if (details) {
    //           if (this.isDebug == true) console.debug('base64pdf........................' + details)
    //             console.debug('type===' + type)

    //           if (
    //             type === 'EscrowLetterDocument' ||
    //             type === 'DisclosureLetterDocument' ||
    //             type === 'BuyerNotificationLetterDocument' ||
    //             type === 'SellerNotificationLetterDocument'
    //           ) {
    //             console.debug('escrowDetail===' + JSON.stringify(this.escrowDetail))

    //             if(this.formData.escrowLetterDocument.indexOf('pdf') > -1) {
    //               const blob = base64toBlob(details, contentType)
    //               showAnyType(blob, contentType)
    //             }
    //             else if(this.formData.disclosureLetterDocument.indexOf('pdf') > -1) {
    //               const blob = base64toBlob(details, contentType)
    //               showAnyType(blob, contentType)
    //             }
    //             else if(this.formData.buyerNotificationLetter.indexOf('pdf') > -1) {
    //               const blob = base64toBlob(details, contentType)
    //               showAnyType(blob, contentType)
    //             }
    //             else if(this.formData.disclosureSentDate.indexOf('pdf') > -1) {
    //               const blob = base64toBlob(details, contentType)
    //               showAnyType(blob, contentType)
    //             }
    //             else if(this.formData.sellerNotificationLetter.indexOf('pdf') > -1) {
    //               const blob = base64toBlob(details, contentType)
    //               showAnyType(blob, contentType)
    //             } else {
    //               const blob = base64toBlob(details, 'text/html')
    //               showAnyType(blob, 'text/html')
    //             }
    //           } else {
    //             const blob = base64toBlob(details, contentType)
    //             showPdf(blob)
    //           }
    //           notifyMessage(`Successfully downloaded the document.`)
    //           return
    //         }
    //       }
    //     })
    //   } catch (e) {
    //     if (this.isDebug == true) console.debug(e)
    //     notifyWarning('There was a problem downloading the document.')
    //   }
  }
}
